// extracted by mini-css-extract-plugin
export default {"three":"SecThree_three__IfhC1","main":"SecThree_main__rmhOU","up":"SecThree_up__GcXzi","down":"SecThree_down__3Fmld"};